import React from 'react';
import { Checkbox } from '@triumph/design-system';
import { useTranslation } from 'react-i18next';
import { CopyToClipboardButton } from '@/app/shared/components/ClipboardCopy/ClipboardCopyButton';
import { BillingReminder } from '../billingReminder.types';
import { OrderedTableColumns } from '@/app/shared/components/DataTable/DataTable.types';
import { InvoiceLink } from './AllInvoicesTable.StyledComponents';

interface AllInvoicesTableColumnsProps {
  allSelected: boolean;
  someSelected: boolean;
  onSelectAll: () => void;
  selectedInvoices: Set<string>;
  onSelectInvoice: (invoiceNumber: string) => void;
}

export const allInvoicesTableColumns = ({
  allSelected,
  someSelected,
  onSelectAll,
  selectedInvoices,
  onSelectInvoice,
}: AllInvoicesTableColumnsProps): OrderedTableColumns[] => {
  const { t } = useTranslation('billingReminder', { keyPrefix: 'table' });

  return [
    {
      order: 0,
      header: '',
      field: 'selection',
      sortable: false,
      renderHeaderLabel: (
        <Checkbox
          id="all-invoices-select-all"
          checked={allSelected}
          indeterminate={someSelected}
          onClick={onSelectAll}
        />
      ),
      dynamicColumnFormatter: (_data: any, row: BillingReminder) => (
        <Checkbox
          key={`checkbox-${row.invoiceId}`}
          id={`checkbox-${row.invoiceId}`}
          checked={selectedInvoices.has(row.invoiceNumber)}
          onClick={() => onSelectInvoice(row.invoiceNumber)}
        />
      ),
    },
    {
      order: 1,
      header: t('invoiceNumber'),
      field: 'invoiceNumber',
      sortable: true,
    },
    {
      order: 2,
      header: t('referenceNumber'),
      field: 'referenceNumber',
      sortable: true,
      dynamicColumnFormatter: (_data: any, row: BillingReminder) => (
        <CopyToClipboardButton value={row.referenceNumber} />
      ),
    },
    { order: 3, header: t('carrierName'), field: 'carrierName', sortable: true },
    { order: 4, header: t('amount'), field: 'amount', sortable: true },
    { order: 5, header: t('invoiceDate'), field: 'invoiceDate', sortable: true },
    { order: 6, header: t('invoiceDueDate'), field: 'invoiceDueDate', sortable: true },
    { order: 7, header: t('age'), field: 'age', sortable: true },
    { order: 8, header: t('status'), field: 'status', sortable: true },
  ];
};
